import { classNames, Component, h, tag } from "omi";

import { COMMUNITY_LINK_WITH_ERROR_UTM } from "@/globals/links.ts";
import { tailwind } from "@/tailwind";

type Props = {
  as?: "text" | "banner";
};

@tag("nw-error")
export class NWError extends Component<Props> {
  static css = [tailwind];

  render({ as = "banner" }: Props) {
    return (
      <div
        class={classNames("text-sm text-error-400 w-full animate-fadeInFast  text-center", {
          "bg-error-50 rounded-xl py-3 px-3 space-y-0.5": as === "banner",
        })}
      >
        <p class="font-medium">Sorry about that! Something went wrong.</p>
        <p>
          Please try refreshing and{" "}
          <a
            href={COMMUNITY_LINK_WITH_ERROR_UTM}
            target="_blank"
            class="underline underline-offset-2 transition-colors hover:text-error-600"
          >
            let us know
          </a>{" "}
          if the problem persists.
        </p>
      </div>
    );
  }
}
